import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "./CallCenterAdminMobile.scss";
import {MicrosoftToken} from "../Services/DashboardService";
import { PowerBiEnum } from "../Enum/PowerBi.Enum";


export const CallCenterAdminMobile = () => {
  const [report, setReport] = useState();
  const [render, setRender] = useState(false);


  const Microsoft = async (isExpired) => {
    const res = await MicrosoftToken(isExpired);
    if (res.data) {
      setReport(res.data || null);
      setRender(true);
    } else {
      setReport(null);
    }
  };
  useEffect(() => {
    Microsoft(false);
  }, []);

  return (
    <div>
      <div>
        {render && (
        <div className='web'>
          <PowerBIEmbed
            embedConfig={{
              type: "report",
              id: PowerBiEnum.CallCenterMobile.reportid,
              embedUrl:PowerBiEnum.CallCenterMobile.url,
              accessToken: report,
              settings: {
                customLayout: {
                  displayOption: models.DisplayOption.FitToWidth,
                },
                filterPaneEnabled: false,
                navContentPaneEnabled: false,
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                },
                background: models.BackgroundType.Transparent,
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  () => {
                    console.log("Report loaded");
                  },
                ],
                [
                  "rendered",
                  () => {
                    console.log("Report rendered");
                  },
                ],
                [
                  "error",
                  (event) => {
                    console.log("Error");
                    const error = event.detail;

                    if (error.detailedMessage === 'Get report failed') {
                      Microsoft(true);
                      setRender(false);

                    } else {
                      console.log(error.message);
                    }
                  },
                ],
              ])
            }
            cssClassName={"report-style-class"}
            getEmbeddedComponent={(embeddedReport) => {
              window.report = embeddedReport;
            }}
          />
        </div>
            )}
      </div>
    </div>
  );
};
